// eslint-disable-next-line import/prefer-default-export
export const GET_DATA = 'GET_DATA';
export const FILTER_DATA = 'FILTER_DATA';
